import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';

Form.Display = ({ inline, label, value, children }) => {
	return (
		<Form.Field inline={inline} >
			<label style={{width: "200px", textAlign: "right", marginRight: "10px"}}>{label}</label>
			{children}
			{value}
		</Form.Field>
	);
};

Form.Display.propTypes = {
	inline: PropTypes.bool,
	label: PropTypes.string,
	value: PropTypes.string.isRequired,
	width: PropTypes.any,
	children: PropTypes.any
};

export default Form;
